import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { unsubscribeEmail } from 'store/actions/auth.action';
import { handleToast, history, localStorageKeyValue } from 'utils/handler';
import Email from '../assets/img/email.png';
import logo from '../assets/img/saw-logo.png';

const Unsubscribe = () => {
  const [btnSubmitted, setBtnSubmitted] = useState(false);
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [closeUID, setCloseUID] = useState('');
  const [type, setType] = useState('');
  const [token, setToken] = useState('');

  useEffect(() => {
    const query = new URLSearchParams(history.location.search);
    const email: string | null = query.get('email') || localStorage.getItem(localStorageKeyValue.userEmail);
    const closeUID: string | null = query.get('closeUID');
    const type = query.get('type') || localStorage.getItem('_unsub_type') || 'buy';
    if (type) localStorage.setItem('_unsub_type', type);
    const token = query.get('token') || localStorage.getItem('_unsub_token');
    if (token && String(token).trim()) {
      const _token = String(token).trim();
      localStorage.setItem('_unsub_token', _token);
      setToken(_token);
    }
    history.replace({ search: '' });
    if (!email) history.push('/');
    setEmail(email || '');
    setCloseUID(closeUID || '');
    setType(type);
  }, []);

  const submit = () => {
    if (email) {
      setBtnSubmitted(true);
      unsubscribeEmail({ email, message, closeUID, type, token }).then((result) => {
        if (result) {
          handleToast({ message: result }, 'success');
          localStorage.removeItem('_unsub_token');
          localStorage.removeItem('_unsub_type');
        }
        history.push('/');
        setBtnSubmitted(false);
      });
    }
  };
  return (
    <div className="content-body ">
      <Helmet>
        <title>Unsubscribe - Saw.com Domain Name Brokerage</title>
      </Helmet>
      <header className="justify-content-start p-2">
        <div className="container">
          <img alt="logo-png" src={logo} onClick={() => history.push('/')} className="header-logo  c-pointer" />
        </div>
      </header>
      <div className="container">
        <div className="text-center justify-content-center">
          <img alt="logo-png" src={Email} className="w35" />
          <div className="title"> Do you want to unsubscribe?</div>
          {/* <div className=''>If you unsubscribe, you will stop receiving our process updated.</div> */}
          {/* <div className=''>We are sorry (apologize) for any inconvenience this may have caused you.</div> */}
          <textarea
            autoComplete="off"
            rows={3}
            className="mt-3 saw-input w80"
            value={message}
            onChange={(e) => {
              setMessage(e.target.value);
            }}
            placeholder={'Message if any...'}
          ></textarea>

          <div className="row justify-content-center">
            <button className="btn btn-grad mt-3" disabled={btnSubmitted} onClick={submit}>
              {btnSubmitted ? <i className="fas fa fa-spinner fa-pulse fa-xl" /> : 'Unsubscribe'}
            </button>
            <button className="btn btn-outline-warning mt-3 text-dark" onClick={() => history.push('/')}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Unsubscribe;
